import { Grid, Typography, Link, Button } from '@mui/material'
import { texts } from '../../../general/texts'
import OTPInput from "otp-input-react";
import colors from '../../../colors';
import { makeStyles } from '@mui/styles';
import React from 'react'
import { useFormik } from 'formik';
import * as yup from 'yup'
import { sendGeneralRequest } from '../../../../features/generalRequest'
import { useSelector, useDispatch } from 'react-redux';
import {selectTopUpData, setShouldDisplayOtpPrompt} from '../../../../features/userInfo/topUpSlice'
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { useNavigate } from 'react-router-dom';
import { selectGlobalDataState } from '../../../../features/global/globalDataSlice';
import { selectUtilityState } from '../../../../features/utilities/utilitySlice';

const OtpPrompt = () => 
{
    const dispatch = useDispatch()
    const topUpDataSliceState = useSelector(selectTopUpData)
    const globalDataSliceState = useSelector(selectGlobalDataState)
    const utilitySliceState = useSelector(selectUtilityState)
    const navigate = useNavigate()
    
    const validationSchema = yup.object({
        otp: yup
          .string()
          .length(4)
          .required()
      }); 

    const formik = useFormik({
        initialValues:{
            otp: '',
        },
        validationSchema: validationSchema,
        onSubmit: values => {
            dispatch(sendGeneralRequest({request: {token: globalDataSliceState.token, value: topUpDataSliceState.cardOnFilePaymentValue, cardID: topUpDataSliceState.selectedCard, fnp: values.otp, transID: utilitySliceState.transactionId, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true}, baseUrlKey:'services', endpoint:'CreditBalanceCardsOnFile'}))
        }
    })

    const handleOtpChange = (otp) => 
    {
        formik.setFieldValue('otp', otp)
        if (otp.length === 4) {
            dispatch(sendGeneralRequest({request: {token: globalDataSliceState.token, value: topUpDataSliceState.cardOnFilePaymentValue, cardID: topUpDataSliceState.selectedCard, fnp: otp, transID: utilitySliceState.transactionId, passkey: utilitySliceState.pin, passkeyType: 1, comeFromWeb: true}, baseUrlKey:'services', endpoint:'CreditBalanceCardsOnFile'}))
        }
        
    }

    const useStyles = makeStyles({
        
        button:{
            background:colors.gradientOrange,
            color:colors.white,
            width:'12%',
            fontFamily:'GerberaBold',
            textTransform:'none',
            fontSize:'1rem',
            '@media (max-width: 899px)':{width:'40%'}
        }
    })

    const classes = useStyles()

    const handleSubmit = (e) => 
    {
        e.preventDefault()
        formik.handleSubmit()
    }


    return(
        <form>        
            <Grid container justifyContent='center' p={3}>
            <Grid container item md={12} xs={12} mt={2} justifyContent={'left'}><Link component={'button'} onClick={() => {dispatch(setShouldDisplayOtpPrompt(false))}}><ArrowBackIosNewIcon color='warning' /></Link></Grid>
                <Grid container item sx={{ width:'100%', '@media (max-width: 899px )' : {width:'50%'}}} marginTop={5} rowSpacing={8}>
                    <Grid item md={12} xs={12} justifyContent='center'>
                        <Typography sx={{ color: colors.gray, fontFamily:'GerberaLight', fontSize:'1.3rem'}} variant="caption">{texts["message-subtitle-phone-verification-top-up"]}</Typography>
                    </Grid>
                    <Grid container item md={12} xs={12} justifyContent={'center'} mb={5}>
                        <OTPInput inputStyles={{borderTop:'none', width:'70px' ,borderLeft:'none', outline:'none', borderRight:'none', fontFamily:'GerberaLight', borderBottomColor:colors.orange, color:colors.darkBlue, fontSize:'2rem', paddingBottom:'3%', height:'68%' }} value={formik.values.otp} onChange={handleOtpChange} autoFocus OTPLength={4} otpType="string" disabled={false} />
                    </Grid>
                </Grid>
                {/* <Grid container item md={12} xs={12}  pt={20} justifyContent='center'>
                    <Button type='submit' onClick={(e)=>{handleSubmit(e)}}  sx={{background:colors.gradientOrange, color:colors.white, width:'100%', fontFamily:'GerberaBold', textTransform:'none', fontSize:'1rem', '@media (max-width: 899px)':{width:'40%'}}}>{texts["button-continue"]}</Button>
                </Grid>                                              */}
            </Grid>
        </form>
    )
}

export default OtpPrompt